/* Util.js */

"use strict";

class Util {
    static isMacOS() {
        let appVersion = navigator.appVersion;
        return appVersion.indexOf("Mac") !== -1;
    }
}

module.exports = Util;
